import React, {useEffect, useState} from 'react';
import {
    Box, Button,
    Card,
    CardContent,
    FormControl,
    Grid,
    IconButton,
    Input,
    InputAdornment, InputLabel,
    Link,
    Typography, useToastProvider
} from "@deere/fuel-react";
import {
    AE_CALENDAR_LINK,
    DATE_CHECK_ERROR, INTER_DATE_CHECK_ERROR,
    MID_YEAR,
    NEXT_RATINGS,
    RATINGS_DUE,
    RATINGS_OPEN,
    YEAR_END
} from "../../Constants";
import LaunchIcon from "@material-ui/icons/Launch";
import {Controller, useForm} from "react-hook-form";
import {formatDate} from "../../utils";
import {DatePicker} from "@deere/ux.uxframe-react";
import {useAuthConfig} from "../../helper";

export const EditCalendar = ({ onSubmit, handleModalClose }) => {
    let authAxios = useAuthConfig();
    const {enqueueToast} = useToastProvider();
    const {control, handleSubmit, setValue} = useForm();
    const [disabled, setDisabled] = useState(true);
    const initState = {
        currentFiscalYear: "",
        nextFiscalYear: "",
        calendarYearEndRatingsOpen: "",
        calendarYearEndRatingsDue: "",
        periodName: ""
    }
    const fiscalYearInitState = {
        midYearRatingsOpen: "",
        midYearRatingsDue: "",
        yearEndRatingsOpen: "",
        yearEndRatingsDue: "",
        calendarUrl: ""
    }
    const [state, setState] = useState(initState);
    const [fiscalYearState, setFiscalYearState] = useState(fiscalYearInitState);
    const [errorMessage, setErrorMessage] = useState("");
    const [midYearError, setMidYearError] = useState("");
    const [yearEndError, setYearEndError] = useState("");
    const [isEmptyNextYear, setIsEmptyNextYear] = useState(false);

    const handleCalendarSubmit = (data) => {
        if (data.midYearRatingsOpen !== "" && data.midYearRatingsDue !== "") {
            if (Date.parse(data.midYearRatingsOpen) >= Date.parse(data.midYearRatingsDue)) {
                setMidYearError(DATE_CHECK_ERROR);
                return false;
            }
        }
        if (data.yearEndRatingsOpen !== "" && data.yearEndRatingsDue !== "") {
            if (Date.parse(data.yearEndRatingsOpen) >= Date.parse(data.yearEndRatingsDue)) {
                setYearEndError(DATE_CHECK_ERROR);
                return false;
            }
        }
        if (data.yearEndRatingsOpen !== "" && data.midYearRatingsDue !== "") {
            if (Date.parse(data.midYearRatingsDue) >= Date.parse(data.yearEndRatingsOpen)) {
                setYearEndError(INTER_DATE_CHECK_ERROR);
                return false;
            }
        }
        if (errorMessage !== "") {
            return false;
        }
        if (isEmptyNextYear) {
            const postData = {
                calendarUrl: fiscalYearState.calendarUrl,
                fiscalYear: state.nextFiscalYear,
                nextRatingPeriods: [
                    {
                        period: 1,
                        openDate: data.midYearRatingsOpen,
                        dueDate: data.midYearRatingsDue
                    },
                    {
                        period: 2,
                        openDate: data.yearEndRatingsOpen,
                        dueDate: data.yearEndRatingsDue
                    }
                ]
            }
            authAxios.post(`/calendar`, postData)
                .then(res => {
                    getCurrentData();
                    enqueueToast({
                        variant: "success",
                        title: "Saved Successfully",
                        isCloseable: true
                    });
                }).catch((error) => {
                enqueueToast({
                    variant: "error",
                    title: "System Error",
                    message: error.response ? error.response.data[error.response.status] : "",
                    isPersistent: true
                });
                console.log(error);
            })

        }
        else {
            const putData = {
                calendarUrl: fiscalYearState.calendarUrl,
                fiscalYear: state.nextFiscalYear,
                nextRatingPeriods: [
                    {
                        id: fiscalYearState.midYearRatingId,
                        period: 1,
                        openDate: data.midYearRatingsOpen,
                        dueDate: data.midYearRatingsDue
                    },
                    {
                        id: fiscalYearState.yearEndRatingId,
                        period: 2,
                        openDate: data.yearEndRatingsOpen,
                        dueDate: data.yearEndRatingsDue
                    }
                ]
            }
            authAxios.put(`/calendar`, putData)
                .then(res => {
                    enqueueToast({
                        variant: "success",
                        title: "Updated Successfully",
                        isCloseable: true
                    });
                }).catch((error) => {
                enqueueToast({
                    variant: "error",
                    title: "System Error",
                    message: error.response ? error.response.data[error.response.status] : "",
                    isPersistent: true
                });
                console.log(error);
            })
        }
        handleModalClose();
    }

    const processData = data => {
        setState({
            ...state,
            calendarUrl: data.calendarUrl,
            currentFiscalYear: data.currentFiscalYear,
            nextFiscalYear: data.nextFiscalYear,
            calendarYearEndRatingsOpen: data.nextRatingPeriod[0].openDate,
            calendarYearEndRatingsDue: data.nextRatingPeriod[0].dueDate,
            periodName: data.nextRatingPeriod[0].period === 1 ? "Mid-Year" : "Year-End"
        })
        getFiscalYearData(data.nextFiscalYear)
    }

    const getCurrentData = async () => {
        await authAxios.get(`calendar/current`)
            .then(res => {
                const data = res.data;
                processData(data)
            }).catch((error) => {
                console.log(error);
            });
    }

    const processFiscalYearData = data => {
        if(data.nextRatingPeriod === null) {
            setIsEmptyNextYear(true)
            setFiscalYearState(fiscalYearInitState)
            setValue("midYearRatingsOpen", "")
            setValue("midYearRatingsDue", "")
            setValue("yearEndRatingsOpen", "")
            setValue("yearEndRatingsDue", "")
            return
        }
        const midYearRatingData = data.nextRatingPeriod.filter(item => item.period === 1)
        const yearEndRatingData = data.nextRatingPeriod.filter(item => item.period === 2)
        setFiscalYearState({
            ...fiscalYearState,
            midYearRatingsOpen: midYearRatingData[0].openDate,
            midYearRatingsDue: midYearRatingData[0].dueDate,
            yearEndRatingsOpen: yearEndRatingData[0].openDate,
            yearEndRatingsDue: yearEndRatingData[0].dueDate,
            calendarUrl: data.calendarUrl,
            midYearRatingId: midYearRatingData[0].id,
            yearEndRatingId: yearEndRatingData[0].id
        })
        if (midYearRatingData.length > 0) {
            setValue("midYearRatingsOpen", formatDate(new Date(midYearRatingData[0].openDate)))
            setValue("midYearRatingsDue", formatDate(new Date(midYearRatingData[0].dueDate)))
        }
        if (yearEndRatingData.length > 0) {
            setValue("yearEndRatingsOpen", formatDate(new Date(yearEndRatingData[0].openDate)))
            setValue("yearEndRatingsDue", formatDate(new Date(yearEndRatingData[0].dueDate)))
        }
        setIsEmptyNextYear(false)
    }

    const getFiscalYearData = async (fiscalYear) => {
        await authAxios.get(`calendar/${fiscalYear}`)
            .then(res => {
                const data = res.data;
                processFiscalYearData(data)
            }).catch((error) => {
                console.log(error);
            });
    }

    const validate = (value) => {
        setFiscalYearState({
            ...fiscalYearState,
            calendarUrl: value
        })
        if(value){
            if (/^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value.toLowerCase())) {
                setErrorMessage('')
            } else {
                setErrorMessage('Enter Valid URL')
            }
        }
        setDisabled(false)
    };

    useEffect(() => {
        getCurrentData();
        return () => {
        }// eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <form onSubmit={handleSubmit((data) =>
            handleCalendarSubmit(data))}>
            <Box display="flex" flexDirection="column">
                <Grid item xs={12}>
                    <Box p={2}>
                        <Card>
                            <CardContent>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <Box pb={4}>
                                            <Typography variant="h4">{NEXT_RATINGS} -
                                                FY{state.nextFiscalYear}</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="h5"
                                                    style={{paddingBottom: ".5rem"}}>{AE_CALENDAR_LINK}</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box pb={4}>
                                            <FormControl fullWidth>
                                                <Input fullWidth
                                                       placeholder="URL"
                                                       id="search"
                                                       name="calendarURL"
                                                       value={fiscalYearState.calendarUrl}
                                                       endAdornment={
                                                           <InputAdornment position="end">
                                                               <Link href={fiscalYearState.calendarUrl} target="_blank"
                                                                     rel="noopener noreferrer">
                                                                   <IconButton aria-label="search">
                                                                       <LaunchIcon style={{color: "#367c2b"}}/>
                                                                   </IconButton>
                                                               </Link>
                                                           </InputAdornment>
                                                       }
                                                       onChange={(e) => {
                                                           validate(e.target.value)
                                                       }}
                                                />
                                            </FormControl>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography color="error" size="xs">
                                            {errorMessage}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box pt={2} pb={1} mb={2} borderBottom={"1px solid #b3b3b3"}>
                                            <Typography variant="h5">{MID_YEAR}</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box pr={2} pb={2} pt={2}>
                                            <FormControl fullWidth>
                                                <InputLabel
                                                    htmlFor="midYearRatingsOpen">{RATINGS_OPEN}</InputLabel>
                                                <Controller
                                                    rules={{required: false}}
                                                    control={control}
                                                    defaultValue={fiscalYearState.midYearRatingsOpen ? formatDate(new Date(fiscalYearState.midYearRatingsOpen)) : ""}
                                                    name="midYearRatingsOpen"
                                                    render={({onChange}) => (
                                                        <DatePicker
                                                            id="uxf-date-picker-1"
                                                            inputAriaLabel="date format: dd-mmm-yyyy"
                                                            name="midYearRatingsOpen"
                                                            inputProps={{value: fiscalYearState.midYearRatingsOpen}}
                                                            hideLabel={true}
                                                            defaultValue={fiscalYearState.midYearRatingsOpen}
                                                            flatPickrOptions={
                                                                {
                                                                    minDate: new Date(),
                                                                    onChange: e => {
                                                                        onChange(e.length > 0 ? formatDate(e[0]) : "",
                                                                            setDisabled(false),
                                                                            setMidYearError(""));
                                                                    }
                                                                }
                                                            }/>
                                                    )}
                                                />
                                            </FormControl>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box p={2}>
                                            <FormControl fullWidth>
                                                <InputLabel
                                                    htmlFor="midYearRatingsDue">{RATINGS_DUE}</InputLabel>
                                                <Controller
                                                    rules={{required: false}}
                                                    control={control}
                                                    defaultValue={fiscalYearState.midYearRatingsDue ? formatDate(new Date(fiscalYearState.midYearRatingsDue)) : ""}
                                                    name="midYearRatingsDue"
                                                    render={({onChange}) => (
                                                        <DatePicker
                                                            id="uxf-date-picker-2"
                                                            inputAriaLabel="date format: DD-Mon-yyyy"
                                                            inputProps={{value: fiscalYearState.midYearRatingsDue}}
                                                            hideLabel={true}
                                                            defaultValue={fiscalYearState.midYearRatingsDue}
                                                            flatPickrOptions={
                                                                {
                                                                    minDate: new Date(),
                                                                    onChange: e => {
                                                                        onChange(e.length > 0 ? formatDate(e[0]) : "",
                                                                            setDisabled(false),
                                                                            setMidYearError(""));
                                                                    }
                                                                }
                                                            }/>
                                                    )}
                                                />
                                            </FormControl>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography color="error" size="xs">
                                            {midYearError}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box pt={2} pb={1} mb={2} borderBottom={"1px solid #b3b3b3"}>
                                            <Typography variant="h5">{YEAR_END}</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box pr={2} pb={2} pt={2}>
                                            <FormControl fullWidth>
                                                <InputLabel
                                                    htmlFor="yearEndRatingsOpen">{RATINGS_OPEN}</InputLabel>
                                                <Controller
                                                    rules={{required: false}}
                                                    control={control}
                                                    defaultValue={fiscalYearState.yearEndRatingsOpen ? formatDate(new Date(fiscalYearState.yearEndRatingsOpen)) : ""}
                                                    name="yearEndRatingsOpen"
                                                    render={({onChange}) => (
                                                        <DatePicker
                                                            id="uxf-date-picker-3"
                                                            inputAriaLabel="date format: DD-Mon-YYYY"
                                                            inputProps={{value: fiscalYearState.yearEndRatingsOpen}}
                                                            hideLabel={true}
                                                            defaultValue={fiscalYearState.yearEndRatingsOpen}
                                                            flatPickrOptions={
                                                                {
                                                                    minDate: new Date(),
                                                                    onChange: e => {
                                                                        onChange(e.length > 0 ? formatDate(e[0]) : "",
                                                                            setDisabled(false),
                                                                            setYearEndError(""));
                                                                    }
                                                                }
                                                            }/>
                                                    )}
                                                />
                                            </FormControl>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box p={2}>
                                            <FormControl fullWidth>
                                                <InputLabel
                                                    htmlFor="yearEndRatingsDue">{RATINGS_DUE}</InputLabel>
                                                <Controller
                                                    rules={{required: false}}
                                                    control={control}
                                                    defaultValue={fiscalYearState.yearEndRatingsDue ? formatDate(new Date(fiscalYearState.yearEndRatingsDue)) : ""}
                                                    name="yearEndRatingsDue"
                                                    render={({onChange}) => (
                                                        <DatePicker
                                                            id="uxf-date-picker-4"
                                                            inputAriaLabel="date format: dd-mmm-yyyy"
                                                            inputProps={{value: fiscalYearState.yearEndRatingsDue}}
                                                            hideLabel={true}
                                                            defaultValue={fiscalYearState.yearEndRatingsDue}
                                                            flatPickrOptions={
                                                                {
                                                                    minDate: new Date(),
                                                                    onChange: e => {
                                                                        onChange(e.length > 0 ? formatDate(e[0]) : "",
                                                                            setDisabled(false),
                                                                            setYearEndError(""));
                                                                    }
                                                                }
                                                            }/>
                                                    )}
                                                />
                                            </FormControl>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography color="error" size="xs">
                                            {yearEndError}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Box>
                </Grid>
                <Box display="flex" justifyContent="flex-end" mt={2} spacing={2}>
                    <Box mr={2}>
                        <Button
                            onClick={handleModalClose}
                            variant="secondary">
                            {'Cancel'}
                        </Button>
                    </Box>
                    <Button
                        onClick={onSubmit}
                        variant="primary"
                        type="submit"
                        disabled={disabled}>
                        {'Submit'}
                    </Button>
                </Box>
            </Box>
        </form>
    )
}